import {
  API_ERROR,
  PRODUCT_GROUPS,
  PRODUCT_CHANGEVALUE,
  PPRODUCT_SELECT_CHANGEVALUE,
  BASEUNIT_SELECT_CHANGEVALUE,
  PRODUCT_UNITS_VALUE,
  PRODUCT_VENDORS_VALUE,
  PRODUCT_IMAGE,
  PRODUCT_GROUP_VALUE,
  PRODUCT_ADD,
  GET_PRODUCT_ROW_DATA,
  GROUP_CHANGEVALUE,
  PRODUCTS,
  PRODUCT_DELETE,
  MODEL_OPEN,
  MODEL_CLOSE,
  UNITS_MODEL_OPEN,
  UNITS_MODEL_CLOSE,
  PRODUCT_LIST_SUCCESSFUL,
  PRODUCT_ADD_SUCCESSFUL,
  PRODUCT_ROW_SUCCESSFUL,
  PRODUCTGROUP_LIST_SUCCESSFUL,
  SET_PARAMS,
  UNITS_CHANGEVALUE,
  DELETE_UNITS_ROW,
  MR_CUSTOM_PRODUCT,
} from "./actionTypes";

export const getProductGroupsList = () => {
  return {
    type: PRODUCT_GROUPS,
  };
};

export const getProducts = (data) => {
  return {
    type: PRODUCTS,
    payload: { data },
  };
};

export const productListSuccessful = (products) => {
  return {
    type: PRODUCT_LIST_SUCCESSFUL,
    payload: products,
  };
};
export const ProductChangeValue = ({ key, value }) => {
  return {
    type: PRODUCT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const UnitsChangeValue = ({ key, value }) => {
  return {
    type: UNITS_CHANGEVALUE,
    payload: { key, value },
  };
};

export const ProductSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: PPRODUCT_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const BaseunitSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: BASEUNIT_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};

export const ProductUnitsValue = ({ name, units, dodelete }) => {
  return {
    type: PRODUCT_UNITS_VALUE,
    payload: { name, units, dodelete },
  };
};
export const DeleteUnitsRow = (index) => {
  return {
    type: DELETE_UNITS_ROW,
    payload: { index },
  };
};

export const ProductVendorsValue = (Pvendors) => {
  return {
    type: PRODUCT_VENDORS_VALUE,
    payload: { Pvendors },
  };
};
export const ProductImage = (Pimage) => {
  return {
    type: PRODUCT_IMAGE,
    payload: { Pimage },
  };
};
export const ProductGroupValue = (Pgroup) => {
  return {
    type: PRODUCT_GROUP_VALUE,
    payload: { Pgroup },
  };
};
export const ProductAdd = (product, image, proId, history, model) => {
  return {
    type: PRODUCT_ADD,
    payload: { product, image, proId, history, model },
  };
};
export const productAddSuccessful = (response) => {
  return {
    type: PRODUCT_ADD_SUCCESSFUL,
    payload: response,
  };
};
export const getProductRowData = (id, history) => {
  return {
    type: GET_PRODUCT_ROW_DATA,
    payload: { id, history },
  };
};
export const product_row_successfull = (products) => {
  return {
    type: PRODUCT_ROW_SUCCESSFUL,
    payload: products,
  };
};
export const GroupChangeValue = ({ key, value }) => {
  return {
    type: GROUP_CHANGEVALUE,
    payload: { key, value },
  };
};

export const productDelete = (proId, history) => {
  return {
    type: PRODUCT_DELETE,
    payload: { proId, history },
  };
};

export const productgroupListSuccessful = (groups) => {
  return {
    type: PRODUCTGROUP_LIST_SUCCESSFUL,
    payload: groups,
  };
};
export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};
export const units_model_open = () => {
  return {
    type: UNITS_MODEL_OPEN,
  };
};

export const units_model_close = () => {
  return {
    type: UNITS_MODEL_CLOSE,
  };
};
export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const MRCustomProduct = (data) => {
  return {
    type: MR_CUSTOM_PRODUCT,
    payload: data,
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
